<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" >
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item  label="企业名称">
                <a-input  v-model="queryParam.enterpriseName"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item  label="市场负责人">
                <a-input  v-model="queryParam.marketPrincipal"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item  label="合同编号">
                <a-input  v-model="queryParam.contractNo"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item  label="合同名称">
                <a-input  v-model="queryParam.contractName"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item   label="合同状态">
                <a-select  v-model="queryParam.forbiddenStatus" allowClear="true">
                  <a-select-option value="0" title="正常">
                    正常
                  </a-select-option>
                  <a-select-option value="1" title="禁用">
                    禁用
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-row>
                <a-col :span="8">
                  <a-select v-model="queryParam.timeType1" allowClear="true">
                    <a-select-option value="auditTime" title="审核时间">
                      审核时间
                    </a-select-option>
                    <a-select-option value="orderTime" title="下单时间">
                      下单时间
                    </a-select-option>
                    <a-select-option value="contractStartTime" title="合同开始时间">
                      合同开始时间
                    </a-select-option>
                    <a-select-option value="contractEndTime" title="合同结束时间">
                      合同结束时间
                    </a-select-option>
                    <a-select-option value="createTime" title="注册时间">
                      注册时间
                    </a-select-option>
                  </a-select>

                </a-col>
                <a-col :span="16">
                  <a-range-picker  style="width: 100%" @change="onChangeTime1" v-model="queryParam.time1" />
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="6">
              <a-row>
                <a-col :span="8">
                  <a-select v-model="queryParam.timeType2" allowClear="true">
                    <a-select-option value="auditTime" title="审核时间">
                      审核时间
                    </a-select-option>
                    <a-select-option value="orderTime" title="下单时间">
                      下单时间
                    </a-select-option>
                    <a-select-option value="contractStartTime" title="合同开始时间">
                      合同开始时间
                    </a-select-option>
                    <a-select-option value="contractEndTime" title="合同结束时间">
                      合同结束时间
                    </a-select-option>
                    <a-select-option value="createTime" title="注册时间">
                      注册时间
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="16">
                  <a-range-picker style="width: 100%" @change="onChangeTime2" v-model="queryParam.time2" />
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="6">
              <a-form-item   label="操作人" style="margin-left: 14px">
                <a-input  v-model="queryParam.operator"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="margin-bottom: 15px">
            <a-col :span="7" :offset="17" :style="{ textAlign: 'right' }">
              <a-button htmlType="submit" type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px;" @click="() => refresh()">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        :loading="loading"
        :columns="columns"
        :data="loadData"
        bordered
        :scroll="{ x: 1000 }"
      >
      <span slot="action" slot-scope="text, record ">
        <a v-if="addEnable" @click="handleEdit(record)">查看</a>
        <a-divider type="vertical" v-if="addEnable" />
        <a v-if="addEnable" @click="handleEdit2(record)">下载</a>
        <a-divider v-if="addEnable && editEnabel || addEnable && removeEnable" type="vertical" />
        <span v-if="editEnabel">
          <a @click="handleb(record.enterpriseId)">编辑</a>
          <a-divider type="vertical"/>
          <a v-if="record.forbiddenStatus==1" @click="showState(record.contractId,record.forbiddenStatus)">启用</a>
          <a v-else @click="showState(record.contractId,record.forbiddenStatus)">禁用</a>
          <a-divider type="vertical" v-if="removeEnable"/>
        </span>
        <a v-if="removeEnable" @click="deleteByIds(record.contractId)">删除</a>
      </span>
      </s-table>
      <enterprise-details ref="details" @ok="handleOk" />
      <p-d-fmodel ref="modal3"></p-d-fmodel>
    </a-card>
    <no-authority v-if="!queryList"></no-authority>
  </div>

</template>

<script>
import { STable } from '@/components'
import { getEnterpriseContractList } from '@/api/enterprise/enterpriseContract'
import { disable, enable, remove } from '@/api/enterprise/contract'
import EnterpriseDetails from './EnterpriseDetails'
import NoAuthority from './NoAuthority'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import PDFmodel from '../master/modules/PDFmodel'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'TableList',
  components: {
    STable,
    EnterpriseDetails,
    PDFmodel,
    NoAuthority
  },
  data () {
    return {
      contractList: [],
      enterpriseId: '',
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      queryParam11: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: '60px',
          dataIndex: 'rowNum',
          align:'center'
        },
        {
          title: '操作',
          width: '60px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseName',
          align:'center'
        },
        {
          title: '企业简称',
          dataIndex: 'enterpriseSimpleName',
          align:'center'
        },
        {
          title: '企业联系人',
          dataIndex: 'enterpriseContacter',
          align:'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align:'center'
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          align:'center'
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          align:'center'
        },
        {
          title: '合同有效期',
          dataIndex: 'contractDuration',
          align:'center'
        },
        {
          title: '合同状态',
          dataIndex: 'forbiddenStatusName',
          align:'center'
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          align:'center'
        },
        {
          title: '上传时间',
          dataIndex: 'uploadTime',
          align:'center'
        }
      ],
      addEnable: checkPermission('enterpriseContractInfo'),
      editEnabel: checkPermission('editEnterpriseContract'),
      removeEnable: checkPermission('deleteEnterpriseContract'),
      queryList: checkPermission('enterpriseContractList:query:list'),
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getEnterpriseContractList(Object.assign(parameter, this.queryParam))
      },
    }
  },
  filters: {
  },
  async created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    getEnterpriseContractList().then(res => {
      this.contractList = res.rows
    })
  },
  methods: {
    refresh () {
      this.queryParam = {}
      this.$refs.table.refresh(true)
    },
    onChangeTime1 (date) {
      if (date) {
        this.queryParam.timeBegin1 = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd1 = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    onChangeTime2 (date) {
      if (date) {
        this.queryParam.timeBegin2 = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd2 = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    //下载
    handleEdit2 (record) {
      window.open(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + record.contractAddress + '&token=' + Vue.ls.get(ACCESS_TOKEN))
    },
    //查看
    handleEdit (record) {
      this.$refs.modal3.delsee(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + record.contractPreviewAddress + '&token=' + Vue.ls.get(ACCESS_TOKEN))
    },
    handleOk () {
      this.$refs.table.refresh()
    },
    deleteByIds (contractId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          remove({ 'ids': contractId }).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              that.handleOk()
            } else {
              that.$message.error(res.msg)
            }
          })
        },
      });

    },
    showState (contractId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        disable({ 'id': contractId }).then(res => {
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enable({ 'id': contractId }).then(res => {
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    handleb (enterpriseId) {
      this.enterpriseId = enterpriseId
      this.$refs.details.edit(enterpriseId,'1',1)
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}

  .twobtn{
    width: 110px;
    font-size: 15px;
  }
</style>
